(function () {
  if (window.__superBonsaiCartStatusTimerReady) return;
  window.__superBonsaiCartStatusTimerReady = true;

  var STORAGE_KEY = 'superbonsai-cart-countdown-deadline-v1';
  var DURATION_MS = 10 * 60 * 1000;

  function getStoredDeadline() {
    try {
      var value = parseInt(window.sessionStorage.getItem(STORAGE_KEY) || '', 10);
      return Number.isFinite(value) ? value : 0;
    } catch (ignore) {
      return window.__superBonsaiCartCountdownDeadline || 0;
    }
  }

  function setStoredDeadline(value) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, String(value));
    } catch (ignore) {
      window.__superBonsaiCartCountdownDeadline = value;
    }
  }

  function clearStoredDeadline() {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (ignore) {
      window.__superBonsaiCartCountdownDeadline = 0;
    }
  }

  function formatTime(milliseconds) {
    var totalSeconds = Math.max(0, Math.ceil(milliseconds / 1000));
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
  }

  function tick() {
    var timers = document.querySelectorAll('[data-sb-cart-timer]');
    if (!timers.length) {
      clearStoredDeadline();
      return;
    }

    var deadline = getStoredDeadline();
    if (!deadline) {
      deadline = Date.now() + DURATION_MS;
      setStoredDeadline(deadline);
    }

    var text = formatTime(deadline - Date.now());
    timers.forEach(function (timer) {
      timer.textContent = text;
    });
  }

  tick();
  window.setInterval(tick, 1000);
})();